import { getView, requireAuth } from '@/lib/utils';
import { AssetsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/chemical-lab',
  component: getView('pages/PageChemicalLabs'),
  name: 'chemical-lab',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'ANALYTICS - LABS',
    leftMenu: Left.AnalyticsLab,
    roles: ['operator'],
    information: AssetsPage,
    showBottomMenu: true,
    isFlowChem: false,
    crumbsIcon: 'flow-dosing',
  },
};
